export default __webpack_public_path__ + "assets/fonts/182674cb4a64e70eee46ba785f33cd60.woff";